/**
 * Legacy `useSubscription` shim — kept so pre-refactor consumers
 * (DashboardLayout, Subscription, TrialEnded, Inventory) continue to work
 * unchanged while the codebase migrates to `useClinicConfig()`.
 *
 * Under the hood everything now flows through `ClinicConfigProvider`, so
 * there is exactly one poller and one source of truth in the app.
 */
import { useClinicConfig } from "@/lib/clinicConfig";

// `sub.*` was the historical field name (see Subscription.jsx). The new
// ClinicConfig payload is a strict superset, so we just alias `sub = config`.
export function useSubscription() {
  const { loading, config, refresh, hasFeature } = useClinicConfig();
  return { loading, sub: config, refresh, hasFeature };
}

export const useFeature = (name) => {
  const { hasFeature, loading } = useClinicConfig();
  return { enabled: hasFeature(name), loading };
};

// Format INR paise → "₹1,499"
export const formatINR = (paise) =>
  `₹${(paise / 100).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

// Warning band for a usage bar (return {color, label} based on % used)
export function usageBand(used, limit) {
  if (!limit) return { color: "#4A6B5D", label: "unlimited", pct: 0 };
  const pct = Math.min(100, Math.round((used / limit) * 100));
  if (pct >= 100) return { color: "#B94A48", label: "limit reached", pct };
  if (pct >= 90)  return { color: "#D06A42", label: "critical",      pct };
  if (pct >= 80)  return { color: "#C89A3A", label: "high",          pct };
  return { color: "#1A362B", label: "healthy", pct };
}
